<template>
  <div class="center-page">
    <van-nav-bar style="background: transparent" :border="false" @click-left="$store.dispatch('back')" placeholder>
      <template #left>
       <van-icon size="40rpx" name="arrow-left" color="#fff"/>
      </template>
    </van-nav-bar>
    <div class="header">
      <img
        :src="
          user.cover ||
          'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/default_avatar.png'
        "
        class="avatar"
        alt=""
      />
      <div class="user">
        <p class="name">{{user.nickname}}</p>
      </div>
      <div class="time">
        <img
          src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/time_icon.png"
          alt=""
        />
        累计学习
        <span>&nbsp;{{ info && info.total_time }}&nbsp;</span>
        分钟
      </div>
      <div class="data" v-if="info">
        <div class="item">
          <p class="value">{{info.today_time}}</p>
          <p class="label">今日学习 (分钟)</p>
        </div>
        <div class="item">
          <p class="value">{{info.day_number}}</p>
          <p class="label">连续学习 (天)</p>
        </div>
        <div class="item">
          <p class="value">{{info.lesson_number}}</p>
          <p class="label">完成课程 (节)</p>
        </div>
      </div>
    </div>
    <div class="record">
      
      <div class="tab">
        <p class="title" :class="{active:activeIndex==1}" @click="activeIndex=1">课程学习记录</p>
        <p class="title" :class="{active:activeIndex==2}"  @click="activeIndex=2">培训学习记录</p>
      </div>
      <div class="list">
        <List
          :loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadmore"
          class="content"
          v-if="list.length"
        >
          <div class="card" v-for="(item,index) in list" :key="index" @click="toDetail(item)">
            <img
              :src="item.cover || 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/nodata.png'"
              alt=""
              class="cover"
            />
            <div class="card-name ellipsis_two">
              {{item.name}}
            </div>
            <div class="pro" v-show="activeIndex==1">
              <span>共{{item.total_lesson_number}}节</span
              ><span
                >已学<b>{{ item.fen }}</b></span
              >
            </div>
            <div class="pro" v-show="activeIndex==2">
              <span>共{{item.total_study_number}}学时</span
              ><span
                >已学<b>{{ item.study_times }}学时</b></span
              >
            </div>
            <div class="lesson">
              <img
                src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/lesson_icon.png"
                alt=""
              /><span class="lesson-name ellipsis">{{item.lesson_name}}</span>
              <div class="go">去学习</div>
            </div>
          </div>
        </List>
        <div class="nodata" style="height: calc(100vh - 550px);" v-else>
          <img
            src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/nodata.png"
            alt=""
          />
          <p>暂无相关内容~</p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import List from "vant/es/list/index";
import "vant/es/list/style/index";

export default {
  components: {
    List,
  },
  computed: {
     user() {
      return localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')) : '';
    },
    flat() {
      return this.$store.state.plat_id
    }
  },
  data() {
    return {
      time: 0,
      page: 1,
      list: [],
      limit: 10,
      loading: false,
      finished: false,
      activeIndex:0,
      trainList: [],
      info:null,
    };
  },
  watch:{
    activeIndex(e){
      this.list = e==1 ? this.info.list : this.info.zi_list
    }
  },
  async mounted () {
    let res = await this.$api({
       method: 'post',
       url: '/api/flat/record/list',
       data: {
          flat_id: this.flat
       }
    });
    if (res.code == 0) {
      this.info = res.data;
      this.activeIndex = 1
      
    }
  },
  methods: {
    loadmore(){

    },
    toDetail(item){
      let url = '../detail?id='+item.goods_id+'&type=video&lessonId='+item.lesson_id
      this.$router.push({
        path:url
      })
    }
  },
};
</script>
 
<style scoped lang="scss">
.center-page {
  background: #ef8784;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.header {
  width: 100%;
  height: 500px;
  background: #ffffff;
  border-radius: 50px 50px 0px 0px;
  margin-top: 116px;
  position: relative;
  padding-top: 90px;
  box-sizing: border-box;
}

.avatar {
  position: absolute;
  top: -76px;
  left: 50%;
  transform: translateX(-50%);
  width: 152px;
  height: 15rpx;
  border-radius: 50%;
}

.user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  box-sizing: border-box;
}

.name {
  font-size: 38px;
  font-weight: 600;
  color: #333;
}

.time {
  font-size: 30px;
  font-weight: 400;
  color: #555550;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-top: 35px;
}

.time > img {
  width: 30px;
  margin-right: 11px;
  margin-bottom: 6px;
}

.time > span {
  font-size: 52px;
  color: #333;
  font-weight: 500;
}

.data {
  width: 690px;
  height: 162px;
  background: #f7f8fa;
  border-radius: 12px;
  margin: 50px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 35px;
  box-sizing: border-box;
  text-align: center;
}

.data .value {
  color: #333;
  font-size: 42px;
  font-weight: 500;
}

.data .label {
  color: #555;
  font-size: 26px;
  margin-top: 10px;
}

.record {
  height: 100%;
  padding-bottom: 20px;
  box-sizing: border-box;
  // margin-bottom: 10px;
  // height: calc(100vh - 720px);
  background: #fff;
  flex:1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  .tab{
    padding-bottom: 20px;
    .title {
      color: #333;
      font-size: 36px;
      padding: 0 30px;
      height: 70px;
      display: flex;
      align-items: center;
      display: inline;

    }
    .active{
      font-weight: 600;
      position: relative;
      &::after{
        content:'';
        position:absolute;
        left:50%;
        transform:translateX(-50%);
        bottom:-15px;
        display: block;
        width: 63px;
        height: 5px;
        background: #A40001;
      }
    }
    
  }
}



.list {
  // height: calc(100% - 90px);
}

.card {
  width: 690px;
  height: 261px;
  background: #f7f8fa;
  border-radius: 12px;
  margin: 0 auto 20px;
  padding: 25px;
  box-sizing: border-box;
}

.cover {
  width: 239px;
  height: 135px;
  border-radius: 8px;
  float: left;
  margin-right: 26px;
}

.card-name {
  width: 372px;
  font-size: 32px;
  color: #333;
  font-weight: 500;
}

.pro {
  display: flex;
  margin-top: 10px;
}

.pro span {
  font-size: 28px;
  color: #666;
  padding: 0 20px;
}

.pro span:first-of-type {
  border-right: 1px solid #d5d5d5;
}

.pro b {
  color: #ff4d41;
}

.lesson {
  width: 100%;
  font-size: 28px;
  color: #333;
  display: flex;
  align-items: center;
  height: 100px;
}
.lesson span{
  flex:1
}

.lesson > img {
  width: 29px;
  margin-right: 12px;
  flex: 0 0 29px;
}

.go {
  width: 131px;
  height: 56px;
  background: #a7090a;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 28px;
  flex: 0 0 131px;
}

.lesson-name {
  flex: 0 1 auto;
}
</style>